import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'

export const CategoryTitle = ({ Icon, title, ...props }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' ,justifyContent:{xs:'center',lg:'unset'} }} {...props}>
            <Box sx={{ display: 'flex', mr: 1 }}>
                <Box sx={{ width: '30px', height: '30px', borderRadius: '50%', backgroundColor: 'rgba(185, 235, 238, 0.42)', marginRight: '-18px' }}></Box>
                <Icon size={'30px'} />
            </Box>
            <Typography fontWeight={'bold'} fontSize={18}>{title}</Typography>
        </Box>
    )
}
